import React from 'react';
import LegalPage from '../components/LegalPage';
import terms from '../legal/terms';

const Terms = () => <LegalPage content={terms} />;

export default Terms;
